module.exports = __webpack_public_path__ + "static/media/400243_01.3f1e11a0.png";